import { Env } from '@/config/environment/env';
import { ONLY_NUMBERS_REGEX } from '@/shared/application/constants/regex/only-numbers-regex';
import CryptoJS from 'crypto-js';
import { cpf, cnpj } from 'cpf-cnpj-validator';

export class CpfCnpj {
  /**
   * Mantém somente os números do CPF/CNPJ
   */
  public static onlyNumbers(cpfCnpj: string) {
    return cpfCnpj.replace(ONLY_NUMBERS_REGEX, '');
  }

  public static masks() {
    return ['999.999.999-99', '99.999.999/9999-99'];
  }

  public static isEqual(value1: string, value2: string) {
    // Mantém apenas os números dos valores informados
    value1 = value1.replace(ONLY_NUMBERS_REGEX, '');
    value2 = value2.replace(ONLY_NUMBERS_REGEX, '');

    if (value1 === value2) {
      return true;
    }

    return false;
  }

  /**
   * Compara o CPF/CNPJ informado com um CPF/CNPJ criptografado, e diz se é igual ou não.
   */
  public static isEqualEncrypted(value: string, encryptedValue: string) {
    let decryptedValue = this.decrypt(encryptedValue);

    // Mantém apenas os números do valor informado
    value = value.replace(ONLY_NUMBERS_REGEX, '');
    decryptedValue = decryptedValue.replace(ONLY_NUMBERS_REGEX, '');

    if (value === decryptedValue) {
      return true;
    }

    return false;
  }

  /**
   * Gera um hash SHA-256 do CPF/CNPJ
   */
  public static hash(cpfCnpj: string) {
    const onlyNumbers = CpfCnpj.onlyNumbers(cpfCnpj);

    return CryptoJS.SHA256(onlyNumbers).toString();
  }

  public static compareWithHash(cpfCnpj: string, hash: string) {
    if (CryptoJS.SHA256(cpfCnpj).toString() === hash) {
      return true;
    }

    return false;
  }

  /**
   * Encripta o CPF/CNPJ.
   */
  public static encrypt(cpfCnpj: string) {
    const onlyNumbers = CpfCnpj.onlyNumbers(cpfCnpj);

    return CryptoJS.AES.encrypt(
      onlyNumbers,
      Env.CRYPTO_KEY_CPF_CNPJ,
    ).toString();
  }

  /**
   * Descriptografa o CPF/CNPJ.
   */
  public static decrypt(cpfCnpj: string) {
    return CryptoJS.AES.decrypt(cpfCnpj, Env.CRYPTO_KEY_CPF_CNPJ).toString(
      CryptoJS.enc.Utf8,
    );
  }

  /**
   * Formata o CPF ou CNPJ com base no valor informado
   */
  public static format(value: string): string {
    const numeric = this.onlyNumbers(value);

    if (cpf.isValid(numeric)) {
      return cpf.format(numeric);
    }

    if (cnpj.isValid(numeric)) {
      return cnpj.format(numeric);
    }

    return value; // retorna como está se não for válido
  }
}
